import {
  IconDocumentSettings,
  IconLanguage,
  SideMenu,
  SideMenuItem,
  Tooltip,
} from "@veneer/core";
import { FlagBR, FlagES, FlagUS } from "@veneer/flags";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import "../../assets/css/components/sidebar.css";
import { IComboDto } from "../../models/dto/generalApi/IComboDto";
import userService from "../../services/generalApi/user.service";
import { useDispatch, useSelector } from "react-redux";
import { changeLanguage } from "../../features/language/changeLanguageSlice";
import languagesMap from "../../utils/maps/languagesSelection";
import modulesRoutes from "../../utils/maps/modulesRoutes";
import { RootState } from "../../app/store";
import { decryptText } from "../../utils/encryptionUtils";
import GetPrivacyPolicyByLanguage from "../../utils/maps/privacyPoliciesByLanguage";
import { addItem } from "../../features/routeState/useRouteState";
import { Item } from "../../features/routeState/useRouteState";

export default function Sidebar() {
  const [t, i18n] = useTranslation("global");
  const [modules, setModules] = useState<IComboDto[]>([]);
  const [currentLanguage, setCurrentLanguage] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state: any = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (Number(decryptText(state.user.userId)) === 0) navigate("/login");
    else {
      userService
        .getModuleByRole(Number(decryptText(state.user.roleId)))
        .then((response: any) => {
          const responseSort = response.sort((a: any, b: any) => a.id - b.id);
          handleRote(responseSort);
          setModules(responseSort);
        })
        .catch((e) => console.error(e));
    }
  }, []);

  function handleChangeLanguage(language: string) {
    const languageId = languagesMap.get(language);
    dispatch(changeLanguage(languageId));
  }

  const handleRote = (dateModule: Item) => {
    dispatch(addItem(dateModule));
  };

  useEffect(() => {
    let language = localStorage.getItem("language");
    if (language !== null) {
      setCurrentLanguage(language);
      changeLanguageMenu(language);
    } else {
      setCurrentLanguage("en");
      changeLanguageMenu("en");
    }
  }, []);

  const changeLanguageMenu = (option: any) => {
    setCurrentLanguage(option);
    handleChangeLanguage(option);
    i18n.changeLanguage(option);
    localStorage.setItem("language", option);
  };

  const getPrivacyPolicy = () => {
    const policy: string = GetPrivacyPolicyByLanguage(i18n.language);
    return policy;
  };

  return (
    <>
      <SideMenu
        appearance="dropShadow"
        position="fixed"
        showIcons
        hideAppHeader={false}
        className="sidebar"
        defaultExpanded
      >
        <div
          style={{ margin: "15px", textAlign: "center", overflow: "hidden" }}
        >
          <p className="h7">{`${decryptText(state.user.name).split(" ")[0]} ${
            decryptText(state.user.lastName).split(" ")[0]
          }`}</p>
          <p className="h7">{decryptText(state.user.role)}</p>
        </div>
        <hr style={{ borderTop: "0.2px solid #bbb" }}></hr>

        {modules.map((module) =>
          Array.from(modulesRoutes).map(([key, value]) => {
            switch (key) {
              case 15:
                return (
                  key === module.id && (
                    <SideMenuItem
                      key={key}
                      label={t(value.name)}
                      icon={value.icon}
                    >
                      <SideMenuItem
                        key={key + 100}
                        label={t(value.name)}
                        link={<Link to={value.route} />}
                      />
                      {modules.some((m) => m.id === 42) && (
                        <SideMenuItem
                          key={key + 101}
                          label={t("header.usersManagementMassive")}
                          link={<Link to={value.route2!} />}
                        />
                      )}
                    </SideMenuItem>
                  )
                );
              case 16:
                return (
                  key === module.id && (
                    <SideMenuItem
                      key={key}
                      label={t(value.name)}
                      icon={value.icon}
                    >
                      <SideMenuItem
                        key={key + 102}
                        label={t("header.createActivation")}
                        link={<Link to={value.route} />}
                      />
                      <SideMenuItem
                        key={key + 103}
                        label={t("header.assignActivation")}
                        link={<Link to={value.route2!} />}
                      />
                      {modules.some((m) => m.id === 47) && (
                        <SideMenuItem
                          key={key + 122}
                          label={t("modal.massAssignmentActivations")}
                          link={<Link to={value.route3!} />}
                        />
                      )}
                    </SideMenuItem>
                  )
                );
              case 17:
                return (
                  key === module.id && (
                    <SideMenuItem
                      key={key}
                      label={t(value.name)}
                      icon={value.icon}
                    >
                      <SideMenuItem
                        key={key + 104}
                        label={t("header.schedulingAgendas")}
                        link={<Link to={value.route} />}
                      />
                      {modules.some((m) => m.id === 36) && (
                        <SideMenuItem
                          key={key + 105}
                          label={t("header.massiveAgendas")}
                          link={<Link to={value.route2!} />}
                        />
                      )}
                      {modules.some((m) => m.id === 41) && (
                        <SideMenuItem
                          key={key + 121}
                          label={t("header.attendance")}
                          link={<Link to={value.route3!} />}
                        />
                      )}
                    </SideMenuItem>
                  )
                );
              case 18:
                return (
                  key === module.id && (
                    <SideMenuItem
                      key={key}
                      label={t(value.name)}
                      icon={value.icon}
                    >
                      <SideMenuItem
                        key={key + 106}
                        label={t("header.course")}
                        link={<Link to={value.route} />}
                      />
                      <SideMenuItem
                        key={key + 107}
                        label={t("header.colleagues")}
                        link={<Link to={value.route2!} />}
                      />
                      <SideMenuItem
                        key={key + 108}
                        label={t("header.trainingLibrary")}
                        link={<Link to={value.route3!} />}
                      />
                      <SideMenuItem
                        key={key + 109}
                        label={t("header.emblems")}
                        link={<Link to={value.route4!} />}
                      />
                    </SideMenuItem>
                  )
                );
              case 24:
                return (
                  key === module.id && (
                    <SideMenuItem
                      key={key}
                      label={t(value.name)}
                      icon={value.icon}
                    >
                      <SideMenuItem
                        key={key + 110}
                        label={t("header.sellOut")}
                        link={<Link to={value.route} />}
                      />
                      <SideMenuItem
                        key={key + 111}
                        label={t("Scorecard")}
                        link={<Link to={value.route2!} />}
                      />
                    </SideMenuItem>
                  )
                );
              case 27:
                return (
                  key === module.id && (
                    <SideMenuItem
                      key={key}
                      label={t(value.name)}
                      icon={value.icon}
                    >
                      <SideMenuItem
                        key={key + 119}
                        label={t("header.attendance")}
                        link={<Link to={value.route} />}
                      />
                      {modules.some((m) => m.id === 44) && (
                        <SideMenuItem
                          key={key + 120}
                          label={t("header.attendanceRoute")}
                          link={<Link to={value.route2!} />}
                        />
                      )}
                    </SideMenuItem>
                  )
                );
              case 32:
                return (
                  key === module.id && (
                    <SideMenuItem
                      key={key}
                      label={t(value.name)}
                      icon={value.icon}
                    >
                      <SideMenuItem
                        key={key + 112}
                        label={t("posManagement.title")}
                        link={<Link to={value.route} />}
                      />
                      <SideMenuItem
                        key={key + 113}
                        label={t("subRetailManagement.title")}
                        link={<Link to={value.route2!} />}
                      />
                    </SideMenuItem>
                  )
                );
              case 34:
                return (
                  key === module.id && (
                    <SideMenuItem
                      key={key}
                      label={t(value.name)}
                      icon={value.icon}
                    >
                      <SideMenuItem
                        key={key + 114}
                        label={t("header.metricsByPeriod")}
                        link={<Link to={value.route} />}
                      />
                      {modules.some((m) => m.id === 39) && (
                        <SideMenuItem
                          key={key + 115}
                          label={t("header.realTimeMetrics")}
                          link={<Link to={value.route2!} />}
                        />
                      )}
                      {modules.some((m) => m.id === 40) && (
                        <SideMenuItem
                          key={key + 116}
                          label={t("header.rankingMetrics")}
                          link={<Link to={value.route3!} />}
                        />
                      )}
                    </SideMenuItem>
                  )
                );
              case 35:
                return (
                  key === module.id && (
                    <SideMenuItem
                      key={key}
                      label={t(value.name)}
                      icon={value.icon}
                    >
                      <SideMenuItem
                        key={key + 117}
                        label={t(value.name)}
                        link={<Link to={value.route} />}
                      />
                      {modules.some((m) => m.id === 43) && (
                        <SideMenuItem
                          key={key + 118}
                          label={t("header.absencesMassiveTitle")}
                          link={<Link to={value.route2!} />}
                        />
                      )}
                    </SideMenuItem>
                  )
                );
              default:
                return (
                  key === module.id && (
                    <SideMenuItem
                      key={key}
                      label={t(value.name)}
                      link={<Link to={value.route} />}
                      icon={value.icon}
                    />
                  )
                );
            }
          })
        )}

        <SideMenuItem
          label={t("header.HPPrivacy")}
          icon={<IconDocumentSettings />}
          onClick={() => window.open(getPrivacyPolicy(), "_blank")}
        />
        <SideMenuItem label={t("header.language")} icon={<IconLanguage />}>
          <Tooltip
            arrow
            contentHideDelayOnHover={300}
            contentShowDelayOnHover={300}
            content={<>{t("header.spanish")}</>}
            id="tooltip"
            placement="top"
          >
            <FlagES
              style={{ cursor: "pointer" }}
              size={48}
              disabled={currentLanguage === "es"}
              onClick={(e) => changeLanguageMenu("es")}
            />
          </Tooltip>
          <Tooltip
            arrow
            contentHideDelayOnHover={300}
            contentShowDelayOnHover={300}
            content={<>{t("header.english")}</>}
            id="tooltip"
            placement="top"
          >
            <FlagUS
              style={{ cursor: "pointer" }}
              size={48}
              disabled={currentLanguage === "en"}
              onClick={(e) => changeLanguageMenu("en")}
            />
          </Tooltip>
          <Tooltip
            arrow
            contentHideDelayOnHover={300}
            contentShowDelayOnHover={300}
            content={<>{t("header.portuguese")}</>}
            id="tooltip"
            placement="top"
          >
            <FlagBR
              style={{ cursor: "pointer" }}
              size={48}
              disabled={currentLanguage === "pt"}
              onClick={(e) => changeLanguageMenu("pt")}
            />
          </Tooltip>
        </SideMenuItem>
      </SideMenu>
    </>
  );
}
